var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSonicSense(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "21px",
    viewBox: "0 0 19 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SonicSense") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DataGate-LP---Action-Buttons",
    transform: "translate(-1020.000000, -427.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SonicSense",
    transform: "translate(1020.000000, 427.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.15,17.1 C15.6256,17.1 15.2,16.67535 15.2,16.15 C15.2,15.6256 15.6256,15.2 16.15,15.2 C16.6744,15.2 17.1,15.6256 17.1,16.15 C17.1,16.67535 16.6744,17.1 16.15,17.1 L16.15,17.1 Z M12.35,17.1 C11.8256,17.1 11.4,16.67535 11.4,16.15 C11.4,15.6256 11.8256,15.2 12.35,15.2 C12.8744,15.2 13.3,15.6256 13.3,16.15 C13.3,16.67535 12.8744,17.1 12.35,17.1 L12.35,17.1 Z M9.5,17.1 L1.9,17.1 L1.9,15.2 L9.5,15.2 L9.5,17.1 Z M17.1,12.35 L10.45,12.35 L10.45,5.7 L8.55,5.7 L8.55,12.35 L1.9,12.35 C0.85215,12.35 0,13.2012 0,14.25 L0,18.05 C0,19.09785 0.85215,19.95 1.9,19.95 L1.9,20.9 L3.8,20.9 L3.8,19.95 L15.2,19.95 L15.2,20.9 L17.1,20.9 L17.1,19.95 C18.14785,19.95 19,19.09785 19,18.05 L19,14.25 C19,13.2012 18.14785,12.35 17.1,12.35 L17.1,12.35 Z",
    id: "Fill-672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.754865,11.12165 L15.411565,9.77835 C17.659265,7.5297 17.659265,3.8703 15.411565,1.62165 L16.754865,0.27835 C19.743565,3.268 19.743565,8.132 16.754865,11.12165",
    id: "Fill-673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.97165,9.010655 L12.62835,7.667355 C13.71325,6.582455 13.7123,4.817355 12.6274,3.732455 L13.97165,2.390105 C15.7966,4.216005 15.7966,7.185705 13.97165,9.010655",
    id: "Fill-674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.245135,11.12165 C-0.743565,8.132 -0.743565,3.268 2.245135,0.27835 L3.588435,1.62165 C1.340735,3.8703 1.340735,7.5297 3.588435,9.77835 L2.245135,11.12165 Z",
    id: "Fill-675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02835,9.010655 C3.2034,7.185705 3.2034,4.216005 5.02835,2.390105 L6.3726,3.732455 C5.2877,4.817355 5.28675,6.582455 6.37165,7.667355 L5.02835,9.010655 Z",
    id: "Fill-676"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicSense);
export default __webpack_public_path__ + "static/media/sonicSense.3a9c7fd6b8ecc0f7aa07bf4a78fe188c.svg";
export { ForwardRef as ReactComponent };